import React from "react";

const CheckedIcon = (props: any) => {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m3.333 8 3.333 3.333 6.667-6.666"
      />
    </svg>
  );
};

export default CheckedIcon;
